import { applyMetaData } from './metaUtils'
import { generateItemListShema } from '~/plugins/structuredData/ItemList'
import { generateBlogPostingSchema } from '~/plugins/structuredData/Article'
import { menuLinks } from '~/utils/menuLinks'

export function generateBlogPostPageMeta(route, blogPost?: any) {
  if (!blogPost) {
    applyMetaData({
      title: 'Blog Post - employers.io',
      description: 'Read our latest article on employers.io.',
      canonical: route.path,
      index: true,
      follow: true
    })
    return
  }
  const schemas = [
    JSON.stringify(generateItemListShema(menuLinks.b2c)),
    JSON.stringify(generateBlogPostingSchema(blogPost))
  ]
  applyMetaData({
    title: `${blogPost.title || 'Blog Post'} | employers.io`,
    description: `${
      blogPost.description || 'Read our latest article on employers.io'
    }. Career Insights for Job Seekers & Recruiters.`,
    canonical: `/blog/${blogPost.slug || ''}`,
    image: blogPost.cover?.formats?.large?.url,
    index: true,
    follow: true,
    schemas
  })
}
export function generateBlogMainPageMeta(route) {
  const schemas = [JSON.stringify(generateItemListShema(menuLinks.b2c))]
  applyMetaData({
    title:
      'Blog - Career Resources for Job Seekers & Recruiters | employers.io',
    description:
      'Stay updated with the latest articles, career advice, and job market trends on employers.io. Our blog offers resources for both job seekers and recruiters.',
    canonical: '/blog',
    index: true,
    follow: true,
    schemas
  })
}
